<template>
  <button class="btn btn-primary ml-2" @click="getDashSettings">
    <i class="mdi mdi-autorenew" :class="{'lm-rotate': loading}"></i>
  </button>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  methods: {
    ...mapActions('settings', ['getDashSettings'])
  },
  computed: {
    ...mapState('settings', ['loading'])
  }
}
</script>

<style lang="sass" scoped>
  .lm-rotate
    &:before
      animation-name: lm-rotate-animation
      animation-duration: 1s
      animation-timing-function: linear
      animation-iteration-count: infinite
      backface-visibility: hidden

  @keyframes lm-rotate-animation
    0%
      transform: rotate(0)
    100%
      transform: rotate(360deg)
</style>
